
import { Component, Vue } from 'vue-property-decorator';

import AppHeader from '@/shared/components/AppHeader.vue';
import LeftMenu from '@/shared/components/LeftMenu.vue';
import Breadcrumb from '@/shared/components/Breadcrumb.vue';
import ConfirmModal from '@/shared/components/ConfirmModal.vue';
import authService from '@/services/auth-services';
import { APP_CONFIG } from '@/config/app-config';
import commonService from '@/services/common-services';
import AppEvents from '@/event.js';
import { eventBus } from '@/main';

@Component({
  components: {
    AppHeader,
    LeftMenu,
    ConfirmModal,
    'bread-crumb': Breadcrumb
  },
})
export default class App extends Vue {
  disableMenuLeft = true;
  disableHeader = true;
  private noteForCustomer = null;
  private isConfirm = false;
  get showMenu() {
    return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
  }
  get showCustomerMessage() {
    return this.$cookies.get('showCustomerMessage');
  }
  private async getConfiguration() {
    if(!this.showCustomerMessage) {
      const result = await commonService.configuration();
      if (result && result.status === 200) {
        this.noteForCustomer = result.data.data.NoteForCustomer;
        this.isConfirm = this.noteForCustomer !== null && this.noteForCustomer !== '';
        if(this.isConfirm) {
          this.$cookies.set('showCustomerMessage', true, 60 * 30);
          this.$modal.show('notify-modal');
        }
      }
    } else { 
      this.$cookies.set('showCustomerMessage', true, 60 * 30);
    }
  }

  private beforeCreate() {
    AppEvents.forEach((item) => {
        this.$on(item.name, item.callback);
      });
    window['getApp'] = this;
  }

  private async created() {
    eventBus.$on(APP_CONFIG.eventBusAction.disableMenuLeft, (data) => {
      this.disableMenuLeft = data;
    });

    eventBus.$on(APP_CONFIG.eventBusAction.disableHeader, (data) => {
      this.disableHeader = data;
    });

    await this.getConfiguration();
  }

  private onCloseModal(eventData: any) {
    this.isConfirm = !eventData.close || false;
    this.$modal.hide('notify-modal');
  }

  private onClickMask() {
    (window['getApp'] as any).$emit('SHOW_HIDE_MENU_LEFT', false);
  }
}
